module.exports = __webpack_public_path__ + "static/media/Lato-LightItalic.88376c87.eot";